import { FC, useState } from 'react'
import { Controller, Control, FieldErrors } from 'react-hook-form'
import clsx from 'clsx'

import styles from './form-textarea-react.module.scss'

interface IProps {
  control: Control<any, any>
  errors: FieldErrors<any>
  name: string
  nameInput?: string
  changeHandler?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
  noErrorOnTouch?: any
  modificator?: string
  modificatorName?: string
  errorModificator?: string
  maxLength?: number
  rules?: {
    required: string
    validate: (val: string) => string | undefined
  }
}
const FormTextarea: FC<IProps> = ({
  control,
  errors,
  rules,
  name,
  changeHandler,
  nameInput,
  noErrorOnTouch,
  modificator,
  modificatorName,
  errorModificator,
  maxLength = Infinity,
  ...props
}: IProps) => {
  const [focusActive, setFocusActive] = useState(false)
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange, onBlur, value, ...rest } }) => {
        const formatedValue = value?.length <= maxLength ? value : value?.slice(0, maxLength)
        return (
          <>
            {nameInput && (
              <div
                className={clsx(styles.label, {
                  [modificatorName as string]: modificatorName,
                })}
              >
                {nameInput}
              </div>
            )}
            <div className={styles.inputWrap}>
              <textarea
                className={clsx(styles.textarea, {
                  [styles.activeInput]: focusActive,
                  [styles.errorInput]: errors[name]?.message,
                  [styles.inputMaxLength]: maxLength !== Infinity && maxLength,
                  [modificator as string]: modificator,
                })}
                onClick={() => noErrorOnTouch?.(name)}
                onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                  onChange(e)
                  changeHandler?.(e)
                }}
                onFocus={() => {
                  setFocusActive(true)
                }}
                value={formatedValue}
                {...props}
                onBlur={() => {
                  onBlur()
                  setFocusActive(false)
                }}
                {...rest}
              ></textarea>
              {maxLength !== Infinity && (
                <div
                  className={clsx(styles.counter, {
                    [styles.counterError]: formatedValue?.length === maxLength,
                  })}
                >
                  {formatedValue?.length || 0}/{maxLength}
                </div>
              )}
            </div>
            <p
              className={clsx(styles.error_text, {
                [styles.active]: errors[name]?.message,
                [errorModificator as string]: errorModificator,
              })}
            >
              {errors[name]?.message}
            </p>
          </>
        )
      }}
    />
  )
}

export default FormTextarea
